/**
 * FileIcon
 *
 * Thin wrapper around the unified <Icon> component for cases where callers
 * have a filename (and optionally an entityType) but no full entity object.
 *
 * All icon resolution is delegated to iconService via fileTypeIcons.ts, so
 * every surface in the app shows the same icon for the same file format.
 */
import React from 'react';
import { Icon } from '../Icon';

interface FileIconProps {
  filename: string;
  entityType?: string;
  size?: number;
  className?: string;
}

const FileIcon: React.FC<FileIconProps> = ({
  filename,
  entityType,
  size = 24,
  className = '',
}) => {
  const entityForIcon = {
    _id: 'file-icon-synthetic',
    entityType: entityType || 'File',
    name: filename,
  } as any;

  const iconSize = size <= 16 ? 'small' : size <= 20 ? 'small' : 'medium';

  return (
    <Icon
      entity={entityForIcon}
      filename={filename}
      size={iconSize as 'small' | 'medium' | 'large'}
      className={className}
    />
  );
};

export default FileIcon;
